import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../hooks/use-user';
import useApiRequest from '../../lib/hooks/useRequest';
import { UserRole, UserType } from '../../lib/interfaces/user';
import Preloader from '../../ui/components/ui/preloader';
import { BillingTermMetaResponseDto, ProductMetaResponseDto } from '../products/types/response';
import OffersPage from './page';

const OffersWrapper = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { apiRequest } = useApiRequest();

  // List and form both need the billing terms, so the page waits for them (Preloader, like the products tab).
  const [billingTerms, setBillingTerms] = useState<BillingTermMetaResponseDto[] | null>(null);

  useEffect(() => {
    if (!user) return;
    if (user.userType !== UserType.Internal || user.userRole === UserRole.User) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    const fetchMeta = async () => {
      const res = await apiRequest<ProductMetaResponseDto>('products/admin/meta', 'GET');
      if (res.data) setBillingTerms(res.data.billingTerms);
    };
    fetchMeta();
  }, [apiRequest]);

  return <div className="flex h-full flex-col gap-5">{billingTerms ? <OffersPage billingTerms={billingTerms} /> : <Preloader />}</div>;
};

export default OffersWrapper;
